// Copyright (c) 2025 Deere & Company

import React, {Component, PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import SearchFilters from '../../../../shared/state/search-filters';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import UpdateAmountOfUseFilterOptions from '../../services/update-amount-of-use-filter-options';
import UpdateAmountOfUseListItem from './update-amount-of-use-list-item';
import {buildNumber} from '../../../../shared/services/build-number';

function handleFilterByChange(filterBy) {

    this.actions.updateAmountOfUseRequestListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateAmountOfUseRequestListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateAmountOfUseRequestListSortDirection(sortDirection);

}

class AmountOfUseAccordion extends Component {

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.amountOfUseRequests];
        sortedCollection = sortCollection(this.props.amountOfUseRequestSearchFilters.sortBy, this.props.amountOfUseRequestSearchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.amountOfUseRequestSearchFilters.filterBy, UpdateAmountOfUseFilterOptions, sortedCollection);

        const title = (
            <FormattedMessage
                id='AMOUNT_OF_USE_REQUESTS_WITH_COUNT'
                values={{
                    count: buildNumber(sortedCollection.length)
                }}
            />
    );

        const body = (

            <UpdateAmountOfUseListItem
                actions={this.props.actions}
                amountOfUseModal={this.props.amountOfUseModal}
                amountOfUseRequestItemToUpdate={this.props.amountOfUseRequestItemToUpdate}
                amountOfUseRequestSearchFilters={this.props.amountOfUseRequestSearchFilters}
                amountOfUseRequests={sortedCollection}
                onFilterByChange={this.props::handleFilterByChange}
                onSortByChange={this.props::handleSortByChange}
                onSortDirectionChange={this.props::handleSortDirectionChange}
                selectedDealers={this.props.selectedDealers}
            />
    );

        return (
            this.props.amountOfUseRequests.length > 0 &&

            <Accordion
                accordionId='amount-of-use-requests'
                body={body}
                title={title}
            />

        );

    }
}

AmountOfUseAccordion.displayName = 'AmountOfUseAccordion';
AmountOfUseAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    amountOfUseModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    amountOfUseRequestItemToUpdate: PropTypes.instanceOf(MeasurementReading).isRequired,
    amountOfUseRequestSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    amountOfUseRequests: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String)),
    updateAmountOfUseModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired
};

export default AmountOfUseAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/update-amount-of-use-accordion.js